// @ts-nocheck
import getConfig from 'next/config'
const {
  publicRuntimeConfig: { intercomAppId },
} = getConfig()

export default function Browser(pluginConfig = {}) {
  return {
    NAMESPACE: 'intercom',
    config: pluginConfig,
    initialize,
    page: () => {
      window.Intercom('update')
    },
    track: ({ payload: { event, properties } }) => {
      window.Intercom('trackEvent', event, properties)
    },
    identify: ({ payload: { userId, traits } }) => {
      window.Intercom('update', {
        avatar: traits?.photoURL,
        user_id: userId,
        email: traits?.email,
        name: traits?.displayName,
        createdAt: traits?.metadata?.creationTime,
        artist: traits?.claims?.artist,
      })
    },
    loaded: () => {
      return !!window.Intercom
    },
  }
}

export function initialize({ config: {}, instance }) {
  if (!intercomAppId) return
  ;(function () {
    var w = window
    var ic = w.Intercom
    if (typeof ic === 'function') {
      ic('reattach_activator')
      ic('update', w.intercomSettings)
    } else {
      var d = document
      var i = function () {
        i.c(arguments)
      }
      i.q = []
      i.c = function (args) {
        i.q.push(args)
      }
      w.Intercom = i
      var l = function () {
        var s = d.createElement('script')
        s.type = 'text/javascript'
        s.async = true
        s.src = 'https://widget.intercom.io/widget/' + intercomAppId
        var x = d.getElementsByTagName('script')[0]
        x.parentNode.insertBefore(s, x)
      }
      if (typeof w.attachEvent === 'function') w.attachEvent('onload', l)
      else w.addEventListener('load', l, false)
    }
  })()

  if (window.Intercom) {
    console.info('initialize intercom', intercomAppId)
    window.Intercom('boot', {
      app_id: intercomAppId,
    })
  }
}

export function trackEvent() {}

export function identifyVisitor() {}

export function pageView() {}
